import React, { useState } from 'react';
import { motion } from 'framer-motion';
import './App.css'; // Assuming you will use the same CSS
import { Link } from 'react-scroll';

const App = () => {
  const [showDetails, setShowDetails] = useState({
    pyramidShow: false,
    noraltaShow: false
  });

  const handleClick = (item) => {
    setShowDetails((prev) => ({
      ...prev,
      [item]: !prev[item]
    }));
  };

  return (

    <div className="App">
      {/* Navigation Bar */}
      <nav className="navbar">
        <Link to="about" smooth={true} duration={600}>About Me</Link>
        <Link to="projects" smooth={true} duration={600}>Projects</Link>
        <Link to="experience" smooth={true} duration={600}>Experience</Link>
        <Link to="contact" smooth={true} duration={600}>Contact</Link>
      </nav>
      
      {/* Header Section */}
      <header className="header">
        <motion.img 
            src={process.env.PUBLIC_URL + "/james.jpg"} 
            alt="Profile" 
            className="profile-picture" 
        />
        <motion.h1
          initial={{ y: -100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 1 }}
        >James Khalil</motion.h1>
        <p>Software Developer | Fullstack</p>
      </header>
      
      {/* About Me Section */}
      <h2>About Me</h2>
      <motion.section 
        id="about" 
        className="aboutme-container"
        initial={{ opacity: 0, x: -100 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
      >


        <motion.img 
            src={process.env.PUBLIC_URL + "/aboutme.jpg"} 
            alt="Profile" 
            className="aboutme-picture" 
        />
        <p>
          My name is James Khalil, and I'm a graduate from the University of Calgary with a bachelors of Computer Science.
          Through my time in University, I've learnt a lot of skills both within school and on my own time, such as cybersecurity, game development,
          software development, and many more!
          I enjoy coding a lot, so much that I have participated in Collegiate Programming Contests every year, and even won the Calgary Collegiate Programming Competition in my last year!
          I am very experienced with software development, both frontend and backend, and have a specific background
          in oil and gas, and finance. As for personally, I love being active, especially through volleyball and basketball, but I
          love all sports!
        </p>
      </motion.section>
      
      {/* Projects Section */}
      <motion.section 
        id="projects" 
        className="section"
        initial={{ opacity: 0, x: 100 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
      >
        <h2>Projects</h2>
        <div className="projects-grid">
        <div className="project">
          <h3>Stock Analysis Software</h3>
          <p>I built software that would parse data from yahoo finance. It would then take said information, and attempt to graph several metrics about it, such as the price, the SMA50, EMA50, 
            and many other metrics. Using the .NET framework and the entity relationship mapping framework, it would parse data but into an excel spreadsheet to build a history for stocks.</p>
            <motion.img 
            src={process.env.PUBLIC_URL + "/stock.png"} 
            alt="Profile" 
            className="small-image" 
        />
        </div>

        <div className="project">
        <h3>AI Scheduling System</h3>
        <p>
          I built a scheduling system for a soccer season. This system worked by giving each part of the schedule weightings ranging from 1-infinite for things such as conflicts, referee preferred times, and other factors, to create the most optimal schedule based on those preferences.
        </p>
        <ul>
          <li>Developed a symbolic AI scheduling system in Java using an AND-tree to efficiently generate optimal scheduling.</li>
          <li>Represented conflicts in scheduling using weightings of the severity/priority of conflict, decided algorithmically.</li>
          <li>Implemented a backtracking algorithm to handle hard constraints and optimize the scheduling process under time limitations.</li>
          <li>Integrated referee availability and preferences, minimizing conflicts with game timing while maintaining fairness.</li>
          <li>Designed a user-friendly interface to allow administrators to input constraints and preferences easily.</li>
        </ul>
      </div>

        <div className="project">
          <h3>Cooking Recommendation App</h3>
          <p>I created a web application to help people decide what food they wanted to make.
            The app would allow you to filter results based on factors such as ethnicity of food,
            the cost of ingredients, the time to make it, and the difficulty of the dish.
            <motion.img 
            src={process.env.PUBLIC_URL + "/cookingapp.png"} 
            alt="Profile" 
            className="small-image" 
        />
          </p>
        </div>


        <div className="project">
          <h3>Zombie Shooter Game</h3>
          <p>I created a video game in java that was about shooting zombies, while projectiles flew around you.
            I created this using javaFX, to create both the animation timer (to allow the game to run frame by frame)
            as well as the screens. It included a high score mechanic, a difficult setter, music, and a gameover screen.
          </p>
          <motion.img 
            src={process.env.PUBLIC_URL + "/zombiegame.png"} 
            alt="Profile" 
            className="small-image" 
        />
        
        </div>


        </div>


        
      </motion.section>
      
      {/* Experience Section */}
      <motion.section 
        id="experience" 
        className="section"
        initial={{ opacity: 0, y: 100 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
      >
        <h2>Experience</h2>

        <div className="experience-container">  {/* Flexbox wrapper */}
          <motion.div className="experience-item" onClick={() => handleClick('noraltaShow')} initial={{ height: 'auto'}} animate={{ height: showDetails.noraltaShow ? 'auto' : 150 }} transition={{ duration: 0.5 }}>
            <motion.img 
              src={process.env.PUBLIC_URL + "/noraltaTechnologies.jpg"} 
              alt="Experience Image" 
              className="experience-image"
            />
            <h3>Noralta Technologies</h3>
            <p>Junior Developer, Fullstack | January 2024 – August 2024</p>
            {showDetails.noraltaShow && (
              <motion.ul
                initial={{ opacity: 0, y: -20 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -20 }}
                transition={{ duration: 0.5 }}
              >
                <motion.li>Supported an older web app written with .NET Framework 4.7, MVC with KnockoutJS and SQL Server 2016</motion.li>
                <motion.li>Assisted in transitioning from the older web app to a modern system with increased efficiency and user comfort</motion.li>
                <motion.li>Built the new system using recent technologies, including Angular v12 and .NET 6.0 (briefly .Net Core 3.1)</motion.li>
                <motion.li>Developed with Angular/Material to implement dynamic, responsive UI, enhancing aesthetics and user experience</motion.li>
                <motion.li>Used Entity Framework to replace Dapper as the chosen ORM for the re-write</motion.li>
                <motion.li>Was responsible for a truck ticketing module, that provided an opportunity to employ skills of the entire
                development cycle, from requirement capturing, designing, implementation, testing and deployment</motion.li>
                <motion.li>Actively participated in code reviews and collaboration to ensure high code quality and adherence to best practices</motion.li>
                <motion.li>Repository was managed through Azure Git and deployment handled by Azure Pipeline</motion.li>
              </motion.ul>
            )}
          </motion.div>

          <motion.div className="experience-item" onClick={() => handleClick('pyramidShow')} initial={{ height: 'auto'}} animate={{ height: showDetails.pyramidShow ? 'auto' : 150 }} transition={{ duration: 0.5 }}>
            <motion.img 
              src={process.env.PUBLIC_URL + "/ARPS.ico"} 
              alt="Experience Image" 
              className="experience-image"
            />
            <h3>Pyramid Solutions</h3>
            <p>Junior Desktop Developer, FullStack | June 2023 - September 2023</p>
            {showDetails.pyramidShow && (
              <motion.ul
                initial={{ opacity: 0, y: -20 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -20 }}
                transition={{ duration: 0.5 }}
              >
                <motion.li>Produced an Algorithmic Stock Trading System that leveraged advanced data analysis techniques for decisions</motion.li>
                <motion.li>Used multi-threading and concurrency to simulate historical trading data and perform hundreds of calls efficiently</motion.li>
                <motion.li>Built an in-house application to monitor numerous financial metrics, as well as maintain a portfolio</motion.li>
                <motion.li>Developed the application as a desktop app in visual basic, using the .NET 4.0 framework and Windows forms</motion.li>
                <motion.li>Used polygon, a rest API, to get financial metrics for hundreds of stocks dating back 5 years in seconds</motion.li>
                <motion.li>Implemented windows services for sections of the application into a service that could run autonomously</motion.li>
                <motion.li>Connected to Alpaca API to perform trades on a portfolio and monitor changes to its valuation</motion.li>
              </motion.ul>
            )}
          </motion.div>
        </div>
      </motion.section>

      {/* Skills Section */}
      <motion.section 
        id="skills" 
        className="section"
        initial={{ opacity: 0, x: -100 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
      >
        <h2>Skills</h2>
        
        <div className="skills-container">
          {[
            { logo: `/html.svg.png`},
            { logo: '/css.png', scale: 2 },
            { logo: '/js.png', scale: 1.9  },
            { logo: '/ts.svg.png' },
            { logo: '/logo192.png' },
            { logo: '/nodejs.png' },
            { logo: '/angular.svg.png', scale: 1.2 },
            { logo: '/python.svg.png' },
            { logo: '/java.wine.png', scale: 2 },
            { logo: '/csharp.png', scale: 1.5 },
            { logo: '/c.png' },
            { logo: '/cpp.svg.png' },
            { logo: '/NET.svg.png' },
            { logo: '/sql.svg.png' },
            { logo: '/mysql.png', scale: 1.4 },
            { logo: '/mongodb.png',scale: 1.3 },
            { logo: '/docker.png', scale: 1.3 },
            { logo: '/Jira.svg.png', scale: 1.2 },
            { logo: '/github.png' },
            { logo: '/git.png', scale: 1.5 },


          ].map((skill, index) => (
            <motion.div 
              key={index} 
              className="skill-card"
              whileHover={{ scale: 1 }}
              whileTap={{ scale: 0.95 }}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
            >
              <img src={process.env.PUBLIC_URL + skill.logo} alt={skill.name} className="skill-logo"
              style={{ 
                transform: skill.scale ? `scale(${skill.scale})` : 'scale(1)'  // Individual scaling
              }}
              />
              <p>{skill.name}</p>
            </motion.div>
          ))}
        </div>
      </motion.section>


      
      {/* Contact Section */}
      <motion.footer 
        id="contact" 
        className="footer"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 1 }}
        viewport={{ once: true }}
      >
        <h2>Contact</h2>
        <div className="links">
          <a href="https://github.com/James-Khalil" target="_blank" rel="noopener noreferrer">GitHub</a>
          <a href="https://linkedin.com/in/james-khalil" target="_blank" rel="noopener noreferrer">LinkedIn</a>
          <a href="mailto:james.khalil44@gmail.com">Email</a>
          <a href={`${process.env.PUBLIC_URL}/Resume__2025.pdf`} 
            target="_blank" 
            rel="noopener noreferrer" 
            download="James_Khalil_Resume.pdf">
            Resume
          </a> 
        </div>
      </motion.footer>
    </div>
  );
};

export default App;
